import React from 'react'

export const JsonIcon = ({
  size = 18,
  color = '#bdbdbd',
  ...props
}: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="3" y="4" width="18" height="16" rx="2" fill="#232347" stroke={color} strokeWidth="1.5" />
    <path d="M8 9h8M8 13h5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)
